<div class="modal-body p-4 p-lg-5">
  @if (isForgotPasswordMode()) {
  <div class="text-center mb-5 fade-in">
    <div
      class="d-inline-flex align-items-center justify-content-center bg-warning-subtle text-warning rounded-circle mb-3"
      style="width: 60px; height: 60px"
    >
      <i class="bi bi-key fs-2" style="font-size: 5em"></i>
    </div>
    <h3 class="fw-bold text-dark">Lupa Password?</h3>
    <p class="text-muted small mb-0">
      Masukkan email Anda untuk mereset password.
    </p>
  </div>

  <div class="mb-4">
    <label for="forgotEmail" class="form-label">Alamat Email Terdaftar</label>
    <input
      type="email"
      class="form-control"
      id="forgotEmail"
      [formControl]="forgotEmailControl"
      placeholder="nama@contoh.com"
      [class.is-invalid]="
        forgotEmailControl.invalid && forgotEmailControl.touched
      "
    />

    @if (forgotEmailControl.invalid && forgotEmailControl.touched) {
    <div class="invalid-feedback text-start">
      @if (forgotEmailControl.hasError('required')) { Email wajib diisi. } @if
      (forgotEmailControl.hasError('email')) { Format email tidak valid. }
    </div>
    }
  </div>

  <button
    type="button"
    class="btn btn-primary w-100 py-2 rounded-pill fw-bold shadow-sm mb-3"
    [disabled]="forgotEmailControl.invalid || loading()"
    (click)="submitForgotPassword()"
  >
    @if (loading()) {
    <span class="spinner-border spinner-border-sm me-2"></span> Memproses... }
    @else { Kirim Link Reset }
  </button>

  <button
    type="button"
    class="btn btn-link w-100 text-decoration-none text-muted small"
    (click)="backToLogin()"
  >
    <i class="bi bi-arrow-left me-1"></i> Kembali ke Login
  </button>

  } @else {

  <div class="text-center mb-5 fade-in">
    <div
      class="d-inline-flex align-items-center justify-content-center bg-primary-subtle text-primary rounded-circle mb-3"
      style="width: 60px; height: 60px"
    >
      <i class="bi bi-person-lock fs-2" style="font-size: 5em"></i>
    </div>
    <h3 class="fw-bold text-dark">Login</h3>
  </div>

  @if (deleted()) {
  <div
    class="alert alert-danger d-flex align-items-center fade show mb-4"
    role="alert"
  >
    <i class="bi bi-x-circle-fill me-2"></i>
    <div>Akun Anda telah dihapus. Hubungi Admin.</div>
  </div>
  }

  <form [formGroup]="loginForm" (ngSubmit)="login()" autocomplete="off">
    <div>
      <label for="email">Alamat Email</label>
      <input
        type="email"
        class="form-control"
        id="email"
        formControlName="mailAddress"
        placeholder="name@example.com"
        [class.is-invalid]="
          form['mailAddress'].invalid && form['mailAddress'].touched
        "
      />

      @if (form['mailAddress'].invalid && form['mailAddress'].touched) {
      <div class="invalid-feedback text-start">
        @if (form['mailAddress'].errors?.['required']) { Email wajib diisi. }
        @if (form['mailAddress'].errors?.['email']) { Format email tidak valid.
        }
      </div>
      }
    </div>

    <div class="mb-3 position-relative">
      <label for="password" class="form-label">Password</label>
      <input
        [type]="hide() ? 'password' : 'text'"
        class="form-control"
        id="password"
        formControlName="password"
        placeholder="Masukkan password"
        [class.is-invalid]="
          form['password'].invalid && form['password'].touched
        "
        style="padding-right: 50px"
      />

      @if (form['password'].invalid && form['password'].touched) {
      <div class="invalid-feedback text-start">Password wajib diisi.</div>
      }
    </div>

    <div class="d-flex justify-content-between align-items-center mb-4">
      <div class="form-check">
        <input type="checkbox" class="form-check-input" id="rememberMe" />
        <label class="form-check-label small text-muted" for="rememberMe"
          >Ingat Saya</label
        >
      </div>

      <a
        href="javascript:void(0)"
        (click)="switchToForgotPassword()"
        class="small text-primary text-decoration-none fw-medium"
      >
        Lupa Password?
      </a>
    </div>

    <button
      type="submit"
      class="btn btn-primary w-100 py-2 rounded-pill fw-bold shadow-sm"
      [disabled]="loginForm.invalid || loading()"
    >
      @if (loading()) {
      <span
        class="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      ></span>
      Memproses... } @else { Masuk Sekarang }
    </button>

    <div class="text-center mt-3">
      <span class="small text-muted">Belum punya akun? </span>
      <a
        href="javascript:void(0)"
        (click)="openRegisterModal()"
        class="small text-primary text-decoration-none fw-medium"
      >
        Daftar Sekarang
      </a>
    </div>
  </form>
  }
</div>
